// approvalConfig.js
import { APPROVAL_TYPE, cashInitialFilterForm, cashSearchInputOptions, chequeInitialFilterForm, chequeSearchInputOptions, getCashFilterFormFields, getChequeFilterFormFields } from './constant';
import { cashColumns } from '../columns/cashColumns';
import { chequeColumns } from '../columns/chequeColumns';
import { endpoint } from 'views/pages/manage/common/constant';
import { getChequeExtensionHistory } from './utils';

export const approvalConfig = {
  [APPROVAL_TYPE.CASH]: {
    heading: 'Cash management approvals',
    subHeading: 'Here you can approve or reject the cash management requests of students',
    permissionKey: 'cashManagementApproval',
    columns: cashColumns,
    outerInputSearchFilter:cashSearchInputOptions,
    filters: getCashFilterFormFields,
    initialFilterForm: cashInitialFilterForm,
    endpoints: {
      searchListing: endpoint.cashManagement.depositSlip.search,
      updateStatus: endpoint.cashManagement.depositSlip.update,
    }

  },

  [APPROVAL_TYPE.CHEQUE]: {
    heading: 'Cheque extension approvals',
    subHeading: 'Here you can approve or reject the cheque management requests of students',
    permissionKey: 'chequeManagementApproval',
    columns: chequeColumns,
    outerInputSearchFilter:chequeSearchInputOptions,
    filters: getChequeFilterFormFields,
    initialFilterForm: chequeInitialFilterForm,
    endpoints: {
      searchListing: endpoint.chequeManagement.dateExtension.search,
      updateStatus: endpoint.chequeManagement.dateExtension.update,
    },
    getAudit: getChequeExtensionHistory
  }
};
